export const CALCULATOR_TOOLTIP_CONTENT_TITLE = 'Calculator Allowed';
export const CALCULATOR_TOOLTIP_CONTENT_DESCRIPTION =
  'On your AP exam, you will not see this icon; each part of the exam will either allow a calculator for all questions or none of them.';
